
import { use, registerTheme } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { UniversalTransition } from 'echarts/features'
import { BarChart } from 'echarts/charts'
import {
  TitleComponent,
  DatasetComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent
} from 'echarts/components'

import VChart from 'vue-echarts'

// custom theme
import themeEnerdata from '@/assets/json/echarts_themes/enerdata.project.json'

use([
  CanvasRenderer,
  UniversalTransition,
  BarChart,
  TitleComponent,
  DatasetComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
  DataZoomComponent
])

// registering custom theme
registerTheme('enerdata-theme', themeEnerdata.theme)

export default {
  name: 'EnerEchartsBar',
  components: {
    VChart
  },
  props: {
    option: {
      type: Object,
      default () {
        return {}
      }
    },
    initOptions: {
      type: Object,
      default () {
        return {}
      }
    },
    updateOptions: {
      type: Object,
      default () {
        return {}
      }
    },
    group: {
      type: String,
      default: null,
      required: false
    }
  },
  data () {
    return {}
  }
}
